export default function checkIfNonCircularRangesOverlap(range, comparisonRange) {
  if (range.start < comparisonRange.start) {
    if (range.end < comparisonRange.start) {
      return false;
    } else {
      return true;
    }
  } else {
    if (range.start > comparisonRange.end) {
      return false;
    } else {
      return true;
    }
  }
}
